import React from 'react';
import { noop, find, head } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { Typeahead } from 'modules/typeahead';
import { searchInputPreloader as SearchInputPreloader } from 'ui/views/generic/searchInput';

/*******************************/

// success view
export const drugPricingDrugSearchSuccess = ( props ) => {

    // get search field
    const searchField = find( props.fields, { name: 'drugSearch' } );

    return (
        <div className='ui-drug-pricing-drug-search'>
            <Typeahead
                className='ui-drug-pricing-drug-search__typeahead'
                size='large'
                url={ searchField.url }
                placeholder={ searchField.placeholder }
                onQueryChange={ props.onQueryChange }
                requestPayload={ props.requestPayload }
                allowFilter={ false }
                borderless={ true }
                onChange={ ( { selected } ) => {
                    props.onSelect( head( selected ) ); // update selected value
                } }
            />
        </div>
    );
};

// set display name
drugPricingDrugSearchSuccess.displayName = 'drugPricingDrugSearchSuccess';

// set default props
drugPricingDrugSearchSuccess.defaultProps = {
    requestPayload: {},
    searchQuery: '',
    fields: [],
    onQueryChange: noop,
    onSelect: noop,
};

// prop types
drugPricingDrugSearchSuccess.propTypes = {};

/*******************************/

// preloader view
export const drugPricingDrugSearchPreloader = () => {
    return (
        <div className='ui-drug-pricing-drug-search-preloader'>
            <SearchInputPreloader
                className='ui-drug-pricing-drug-search-preloader__search'
                borderless={ true }
            />
        </div>
    );
};

// set display name
drugPricingDrugSearchPreloader.displayName = 'drugPricingDrugSearchPreloader';

// set default props
drugPricingDrugSearchPreloader.defaultProps = {};

// prop types
drugPricingDrugSearchPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { drugPricingDrugSearch as DrugPricingDrugSearch } from 'ui/views/widgets/drugPricingDrugSearch';
 *
 * // render
 * <DrugPricingDrugSearch propName='propValue'/>
 */
export const drugPricingDrugSearch = withNetworkState( drugPricingDrugSearchPreloader, drugPricingDrugSearchSuccess );
